import EventEmitter from 'wolfy87-eventemitter';
import {VideoItem} from "../../../model/items/video";

class YouTubePlayer {
    private _initialized = false;
    private _eventQueue = new EventEmitter();

    show(c:VideoItem, element:Element) {
        this.initAPI();
        var player = this.createPlayer(c, element);
        this.showPlayer(player);
    };

    private initAPI() {
        if (this._initialized) {
            return;
        }
        this._initialized = true;

        // Load YouTube API
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode!.insertBefore(tag, firstScriptTag); // <script> is not root of HTML dom, thus it has parent

        // Bind ready event
        window.onYouTubeIframeAPIReady = () => this._eventQueue.emit('ready', window.YT);
    }

    private createPlayer(videoItem:VideoItem, element:Element) {
        /* tslint:disable */
        return (YT: any) => {
            return new YT.Player(element, {
                height: videoItem.height,
                width: videoItem.width,
                videoId: videoItem.videoId,
                events: {
                    //'onReady': onPlayerReady,
                    onStateChange: (event: any) => {
                        if (event.data === 0 /* finished */) {
                            videoItem.setFinished();
                        }
                    }
                },
                playerVars: {
                    controls: 0,
                    autoplay: videoItem.autoPlay ? 1 : 0,
                    loop: 0,
                    rel: 0,
                    autohide: 0,
                    showinfo: 0,
                    modestbranding: 1
                }
            });
        };
        /* tslint:enable */
    }

    private showPlayer(player: any) {
        // callback is called after YT api is ready
        // youtube player initialized too early does not work correctly
        setTimeout(() => {
            if (window.YT?.loaded) {
                player(window.YT);
            } else {
                this._eventQueue.on('ready', player);
            }
        }, 100);
    }
}

export var youTubePlayer = new YouTubePlayer();
